/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Check_HintInputs */

const vi_grower_area_camera_check_hint = /** @type {(inputs: Grower_Area_Camera_Check_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiểm tra chạy ở máy chủ, không gửi tài khoản camera xuống trình duyệt.`)
};

/**

* @param {Grower_Area_Camera_Check_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_check_hint = /** @type {((inputs?: Grower_Area_Camera_Check_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Check_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_check_hint(inputs)
});